export default "__VITE_ASSET__zpsE8yXi__"